module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"Pattern":{"hatch":"图案"}},"en":{"Pattern":{"hatch":"Hatch"}},"fr":{"Pattern":{"hatch":"Hatch"}},"de":{"Pattern":{"hatch":"Hatch"}},"jp":{"Pattern":{"hatch":"網掛け"}},"es":{"Pattern":{"hatch":"Sombreado"}},"pt":{"Pattern":{"hatch":"Escotilha"}},"it":{"Pattern":{"hatch":"Tratto"}},"tw":{"Pattern":{"hatch":"圖案"}}}')
  delete Component.options._Ctor
}
